module.exports = __webpack_public_path__ + "img/danny.59fe5bc6.jpg";